import { useEffect, useRef } from "react";
import lottie, { AnimationItem } from "lottie-web";

export function LottieThumbnail({ src, size = 90 }: { src: Record<string, unknown>; size?: number }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    animRef.current?.destroy();
    animRef.current = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: src,
    });
    return () => {
      animRef.current?.destroy();
      animRef.current = null;
    };
  }, [src]);

  return (
    <div
      ref={containerRef}
      className="bg-black/20 rounded-xl overflow-hidden"
      style={{ width: size, height: size }}
    />
  );
}
